<script setup lang="ts">
import { IonIcon } from '@ionic/vue';
import { calendarClearOutline, linkOutline, locationOutline, timeOutline } from 'ionicons/icons';
</script>

<template>
	<div class="ticket-detail-item min-w-[300px] h-[620px]">
		<div class="flex items-center justify-center h-[256px]">
			<img src="@/statics/svg-delete-after-implement/qr-code.svg" class="w-[180px]" />
		</div>

		<div class="absolute flex top-[232px] left-0 right-0 items-center justify-center">
			<div class="flex px-6 py-4 bg-black rounded-full font-sourcesanspro-semibolditalic text-xs2 text-white/70">
				<ion-icon :icon="linkOutline" class="mr-2 text-white"></ion-icon>
				Your wallet linked
			</div>
		</div>

		<div class="flex mt-10 items-center justify-center mb-8">
			<div class="flex flex-col items-center justify-center font-sourcesanspro-semibold text-dark-blue">
				<span class="text-lg24">Derek McLean</span>
				<span class="text-xs2">Le Noël de Monsieur</span>
			</div>
		</div>

		<div class="px-6 text-dark-blue/70">
			<div class="flex items-center justify-between mb-4">
				<span class="font-sourcesanspro-bold text-base">TYPE</span>
				<div class="flex h-[24px] px-3 items-center justify-center bg-anykrowd-ticket-type-green rounded-md">
					<span class="font-sourcesanspro-semibold text-base2 text-white">Copper</span>
				</div>
			</div>
			<div class="flex items-center justify-between mb-4">
				<div class="flex flex-col">
					<span class="font-sourcesanspro-bold text-base">DATE</span>
					<span class="font-sourcesanspro-regular text-base2">Friday 23 Dec, 2022</span>
				</div>
				<ion-icon :icon="calendarClearOutline" class="text-dark-blue"></ion-icon>
			</div>
			<div class="flex items-center justify-between mb-4">
				<div class="flex flex-col">
					<span class="font-sourcesanspro-bold text-base">TIME</span>
					<span class="font-sourcesanspro-regular text-base2">12:30pm</span>
				</div>
				<ion-icon :icon="timeOutline" class="text-dark-blue"></ion-icon>
			</div>
			<div class="flex items-center justify-between mb-4">
				<div class="flex flex-col">
					<span class="font-sourcesanspro-bold text-base">VENUE</span>
					<span class="font-sourcesanspro-regular text-base2">Antwerps Sportpalies, BE</span>
				</div>
				<ion-icon :icon="locationOutline" class="text-dark-blue"></ion-icon>
			</div>
		</div>
	</div>
</template>

<style scoped>
.ticket-detail-item {
	background: url('@/statics/svg/ticket-detail-item.svg') no-repeat;
	background-size: cover;
	position: relative;
}
</style>
